import { FC, PropsWithChildren } from "react";
import styles from "./Table.module.scss";

const TableInput: FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className={styles.inputHolder}>
            {children}
            <img src="/images/scam/search.svg" alt="" />
        </div>
    );
};

export default TableInput;
